import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {NgIdleKeepaliveModule} from '@ng-idle/keepalive'
import { ExportDirective } from './directives/export.directive';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IconsProviderModule } from './icons-provider.module';
import { NgZorroAntdModule, NZ_I18N, en_US } from 'ng-zorro-antd';
import { FormsModule } from '@angular/forms';
import{LoginComponent} from './login/login.component'
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { registerLocaleData, AsyncPipe } from '@angular/common';
import en from '@angular/common/locales/en';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { AngularFireModule } from '@angular/fire';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { UserComponent } from './pages/CommonModule/Users/user/user.component';
import { UsersComponent } from './pages/CommonModule/Users/users/users.component';
import { DashboardComponent } from './pages/CommonModule/Dashboard/dashboard/dashboard.component';
import { RolesComponent } from './pages/CommonModule/Roles/roles/roles.component';
import { RoleComponent } from './pages/CommonModule/Roles/role/role.component';
import {FormsComponent} from './pages/CommonModule/Forms/forms/forms.component'
import {FormComponent} from './pages/CommonModule/Forms/form/form.component'
import {RoledetailsComponent} from './pages/CommonModule/Roles/roledetails/roledetails.component';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ResetpasswordComponent } from './pages/CommonModule/resetpassword/resetpassword.component';
import { BrancheComponent } from './pages/branche/branche.component';
import { BranchesComponent } from './pages/branches/branches.component';
import { OfficeComponent } from './pages/Offices/office/office.component';
import { OfficesComponent } from './pages/Offices/offices/offices.component';
import { OfficersComponent } from './pages/Officers/officers/officers.component';
import { OfficerComponent } from './pages/Officers/officer/officer.component';
import { DiretorsComponent } from './pages/Directors/diretors/diretors.component';
import { DiretorComponent } from './pages/Directors/diretor/diretor.component';
import { HomepagesComponent } from './pages/Homepage/homepages/homepages.component';
import { HomepageComponent } from './pages/Homepage/homepage/homepage.component';
import { MasterdetailsComponent } from './pages/MasterDetails/masterdetails/masterdetails.component';
import { MasterdetailComponent } from './pages/MasterDetails/masterdetail/masterdetail.component';
import { ArchivementmastersComponent } from './pages/Achivements/archivementmasters/archivementmasters.component';
import { ArchivementmasterComponent } from './pages/Achivements/archivementmaster/archivementmaster.component';
import { OrginfosComponent } from './pages/AboutUs/orginfos/orginfos.component';
import { OrginfoComponent } from './pages/AboutUs/orginfo/orginfo.component';
 import { AngularEditorModule } from '@kolkov/angular-editor';
import { FinancialstatusyearsComponent } from './pages/FinancialData/financialstatusyears/financialstatusyears.component';
import { FinancialstatusyearComponent } from './pages/FinancialData/financialstatusyear/financialstatusyear.component';
import { DepositeintrestratesComponent } from './pages/DepositeRates/depositeintrestrates/depositeintrestrates.component';
import { DepositeintrestrateComponent } from './pages/DepositeRates/depositeintrestrate/depositeintrestrate.component';
import { LoansComponent } from './pages/Loans/loans/loans.component';
import { LoanComponent } from './pages/Loans/loan/loan.component';
import { LoanintrestratesComponent } from './pages/LoanRates/loanintrestrates/loanintrestrates.component';
import { LoanintrestrateComponent } from './pages/LoanRates/loanintrestrate/loanintrestrate.component';
import { DepositesComponent } from './pages/Deposites/deposites/deposites.component';
import { DepositeComponent } from './pages/Deposites/deposite/deposite.component';
import { GallarygroupmastersComponent } from './pages/Gallary/gallarygroupmasters/gallarygroupmasters.component';
import { GallarygroupmasterComponent } from './pages/Gallary/gallarygroupmaster/gallarygroupmaster.component';
import { GallerymastersComponent } from './pages/Gallary/gallerymasters/gallerymasters.component';
import { GallerymasterComponent } from './pages/Gallary/gallerymaster/gallerymaster.component';
import { FinancialyeardatasComponent } from './pages/FinancialData/financialyeardatas/financialyeardatas.component';
import { FinancialyeardataComponent } from './pages/FinancialData/financialyeardata/financialyeardata.component';
import { InvestmentsComponent } from './pages/Investments/investments/investments.component';
import { InvestmentComponent } from './pages/Investments/investment/investment.component';
import { SevicemastersComponent } from './pages/Services/sevicemasters/sevicemasters.component';
import { SevicemasterComponent } from './pages/Services/sevicemaster/sevicemaster.component';
import { DepositeschemesComponent } from './pages/DepositeSchemes/depositeschemes/depositeschemes.component';
import { DepositeschemeComponent } from './pages/DepositeSchemes/depositescheme/depositescheme.component';


registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
    ExportDirective,
    LoginComponent,
    UserComponent,
    UsersComponent,
    DashboardComponent,
    RolesComponent,
    RoleComponent,
   FormsComponent,
   FormComponent,
   RoledetailsComponent,
   ResetpasswordComponent,
   BrancheComponent,
   BranchesComponent,
   OfficeComponent,
   OfficesComponent,
   OfficersComponent,
   OfficerComponent,
   DiretorsComponent,
   DiretorComponent,
   HomepagesComponent,
   HomepageComponent,
   MasterdetailsComponent,
   MasterdetailComponent,
   ArchivementmastersComponent,
   ArchivementmasterComponent,
   OrginfosComponent,
   OrginfoComponent,
   FinancialstatusyearsComponent,
   FinancialstatusyearComponent,
   DepositeintrestratesComponent,
   DepositeintrestrateComponent,
   LoansComponent,
   LoanComponent,
   LoanintrestratesComponent,
   LoanintrestrateComponent,
   DepositesComponent,
   DepositeComponent,
   GallarygroupmastersComponent,
   GallarygroupmasterComponent,
   GallerymastersComponent,
   GallerymasterComponent,
   FinancialyeardatasComponent,
   FinancialyeardataComponent,
   InvestmentsComponent,
   InvestmentComponent,
   SevicemastersComponent,
   SevicemasterComponent,
   DepositeschemesComponent,
   DepositeschemeComponent
  ],
  imports: [
    BrowserModule,
    AngularEditorModule,
    Ng2SearchPipeModule,
    AppRoutingModule,
    IconsProviderModule,
    NgZorroAntdModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    NgIdleKeepaliveModule.forRoot()
  ],
  providers: [{ provide: NZ_I18N, useValue: en_US },CookieService,AsyncPipe],
  bootstrap: [AppComponent]
})
export class AppModule { }
